module.exports = __webpack_public_path__ + "static/media/rocket.abcb8424.png";